import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  FormFieldComponent,
  InputDirective,
  InputErrorComponent,
} from '@cf/shared/forms/form-field';
import { ButtonComponent, LinkComponent } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { TextComponent } from '@cf/shared/ui/typography';
import { IBookingMember, SchemaAppEventDetail } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { BookingInformationComponent } from '../../shared/booking-information/booking-information.component';
import { ParticipantListComponent } from '../../shared/participant-list/participant-list.component';

@Component({
  selector: 'cf-reschedule-reason',
  templateUrl: './reschedule-reason.component.html',
  styleUrls: ['./reschedule-reason.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    LinkComponent,
    NgxTolgeeModule,
    BookingInformationComponent,
    ParticipantListComponent,
    ReactiveFormsModule,
    InputErrorComponent,
    InputDirective,
    FormFieldComponent,
    TextComponent,
    NgIf,
    CfIconDirective,
  ],
})
export class RescheduleReasonComponent {
  @Input({ required: true }) form!: FormGroup;

  @Input({ required: true }) event!: SchemaAppEventDetail;
  @Input({ required: true }) timezone!: string;
  @Input({ required: true }) time!: string;
  @Input({ required: true }) day!: string;
  @Input({ required: true }) duration!: string;
  @Input() participants!: IBookingMember[];

  @Output() emitBack = new EventEmitter();
  @Output() emitSubmit = new EventEmitter();

  get participantNames(): string[] {
    if (!this.event?.attendees) {
      return [];
    }

    const userNames: string[] = this.event.attendees
      .filter((a) => !a.self)
      .map((a) => (a.attendee ? (a.attendee.name ?? '') : (a.user?.name ?? '')));
    return [...new Set(userNames)].filter((n) => !!n);
  }

  submit() {
    this.emitSubmit.emit({ ...this.form.value });
  }
}
